import React, { useEffect, useState } from "react";
import { Exercise } from "../../models/Exercise";
import useCalendarSale from "../ThreeStep/hooks/useCalendarSale";
import { useNavigate } from "react-router-dom";
import { TOUR_DETAILS } from "../../routes";
import {
  setExerciseDescription,
  setExerciseName,
  setExerciseZoneId,
} from "../../store/pseudoModal/pseudoModalsActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import LightBox from "../../../features/LightBox";
import { useTranslation } from "react-i18next";
import { State } from "../../store";
import useCountHtmlTagCharacters from "../../../utils/hooks/useCountHtmlTagCharacters";
import EAButton from "../shared/Buttons/EAButton";
import { useMediaQuery } from "@material-ui/core";
import ReadMore from "../../../features/ReadMore";

interface IProps {
  exercise: Exercise;
}

const MainBannerTours: React.FC<IProps> = ({ exercise }: IProps) => {
  const { t } = useTranslation();
  const ids = useSelector((state: State) => state.config.facilityIds);
  const navigate = useNavigate();
  const [openLightBox, setOpenLightBox] = useState(false);
  const { getTicketsByExercise, tickets } = useCalendarSale();
  const { countHtmlTagCharacters } = useCountHtmlTagCharacters();
  const isDesktop = useMediaQuery("(min-width:900px)");
  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup, exercise);
    //eslint-disable-next-line
  }, []);
  const dispatch = useDispatch();
  const lowestPrice = tickets.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);

  const updateState = () => {
    navigate(
      `${TOUR_DETAILS}?id=${ids}&exerciseName=${exercise.name.replace(/%/g, "%25")}&exerciseIds=${
        exercise.zone.objectId
      }`
    );
    dispatch(setExerciseName(exercise.name));
    dispatch(setExerciseZoneId(exercise.zone.objectId));
    dispatch(setExerciseDescription(exercise.description));
    window.parent.postMessage("scroll::", "*");
  };

  return (
    <div className="sale-banner shadow flex-between-center border">
      <div
        style={{ backgroundImage: `url(${exercise.eventMessage})` }}
        className="sale-banner-img"
        onClick={() => setOpenLightBox(!openLightBox)}
      ></div>

      <div className="sale-banner-text readmore-left">
        <h3>{exercise.name}</h3>

        {exercise.description.length > 160 + countHtmlTagCharacters(exercise.description) ? (
          <ReadMore
            text={exercise.description}
            minLengthText={160 + countHtmlTagCharacters(exercise.description)}
            title={exercise.name}
          />
        ) : (
          <article dangerouslySetInnerHTML={{ __html: exercise.description }}></article>
        )}
      </div>

      <div className="sale-banner-buttons">
        <b>
          {lowestPrice !== Infinity ? (
            <>
              {isDesktop ? (
                <>
                  {t("ceny_od")} {lowestPrice} {t("zl")}
                </>
              ) : (
                <>
                  {t("od")} {lowestPrice} {t("zl")}
                </>
              )}
            </>
          ) : (
            <LoadingSpinner />
          )}
        </b>
        <EAButton title={t("wybierz")} onClick={() => updateState()} />
      </div>

      {openLightBox && (
        <LightBox
          imageUrl={exercise.eventMessage}
          open={openLightBox}
          closeModal={() => setOpenLightBox(false)}
          onAccept={() => {}}
        ></LightBox>
      )}
    </div>
  );
};

export default MainBannerTours;
